import { render, staticRenderFns } from "./trumpet.vue?vue&type=template&id=3ffe1f50"
import script from "./trumpet.vue?vue&type=script&lang=js"
export * from "./trumpet.vue?vue&type=script&lang=js"
import style0 from "./trumpet.vue?vue&type=style&index=0&id=3ffe1f50&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports